function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDataRepositoryManaged(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 172 172",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M118.25 136.167h-64.5L21.5 77.04l32.25-59.123h64.5L150.5 77.04z",
    style: {
      fill: "teal",
      fillOpacity: 1,
      strokeWidth: 12.404,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 172V0h172v172z",
    fill: "none",
    style: {
      fontFamily: "none",
      mixBlendMode: "normal",
      fillRule: "nonzero",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeDashoffset: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 7h-6.1l-2-2H6.5C5.7 5 5 5.7 5 6.5v9c0 .8.7 1.5 1.5 1.5h12c.8 0 1.5-.7 1.5-1.5v-7c0-.8-.7-1.5-1.5-1.5Z",
    style: {
      fill: "#cc8000",
      fillOpacity: 1
    },
    transform: "matrix(4.66667 0 0 4.66667 74.717 56.32)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 7h-12C5.7 7 5 7.7 5 8.5v7c0 .8.7 1.5 1.5 1.5h12c.8 0 1.5-.7 1.5-1.5v-7c0-.8-.7-1.5-1.5-1.5Z",
    style: {
      fill: "#dba400",
      fillOpacity: 1
    },
    transform: "matrix(4.66667 0 0 4.66667 74.717 56.32)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 7h-6.1l-2-2H6.5C5.7 5 5 5.7 5 6.5v9c0 .8.7 1.5 1.5 1.5h12c.8 0 1.5-.7 1.5-1.5v-7c0-.8-.7-1.5-1.5-1.5Z",
    style: {
      fill: "#e59000",
      fillOpacity: 1
    },
    transform: "matrix(4.66667 0 0 4.66667 56.721 72.287)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 7h-12C5.7 7 5 7.7 5 8.5v7c0 .8.7 1.5 1.5 1.5h12c.8 0 1.5-.7 1.5-1.5v-7c0-.8-.7-1.5-1.5-1.5Z",
    style: {
      fill: "#f5b800",
      fillOpacity: 1
    },
    transform: "matrix(4.66667 0 0 4.66667 56.721 72.287)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 7h-6.1l-2-2H6.5C5.7 5 5 5.7 5 6.5v9c0 .8.7 1.5 1.5 1.5h12c.8 0 1.5-.7 1.5-1.5v-7c0-.8-.7-1.5-1.5-1.5Z",
    style: {
      fill: "#ffa000"
    },
    transform: "matrix(4.66667 0 0 4.66667 37.794 89.933)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 7h-12C5.7 7 5 7.7 5 8.5v7c0 .8.7 1.5 1.5 1.5h12c.8 0 1.5-.7 1.5-1.5v-7c0-.8-.7-1.5-1.5-1.5Z",
    style: {
      fill: "#ffca28"
    },
    transform: "matrix(4.66667 0 0 4.66667 37.794 89.933)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataRepositoryManaged);
export default __webpack_public_path__ + "static/media/dataRepositoryManaged.f810c438f8e41fa424e8d7355116d484.svg";
export { ForwardRef as ReactComponent };